import Swiper, { Navigation, Pagination, EffectFade, Controller } from 'swiper';
import 'swiper/swiper.scss'
import 'swiper/components/effect-fade/effect-fade.scss'

Swiper.use([Navigation, Pagination, EffectFade, Controller]);

const settings = {
    valuesTextSliderSelector: '[js-slider-values-text]',
    valuesImageSliderSelector: '[js-slider-values-img]',
    flexSliderSelector: '[js-flex-slider]',
    reassuranceSliderSelector: '[js-slider-reassurance]'
}

/*--------------------------
Slider app values
--------------------------*/

let valuesImagesSlider = new Swiper(settings.valuesImageSliderSelector, {
    slidesPerView: 1,
    spaceBetween: 48,
    centeredSlides: false,
    loop: true,
    navigation: {
        nextEl: '[js-slider-values-next]',
        prevEl: '[js-slider-values-prev]',
    },
});


/*--------------------------
Slider values TEXT
--------------------------*/

let valuesTextSlider = new Swiper(settings.valuesTextSliderSelector, {
    spaceBetween: 0,
    slidesPerView: 1,
    effect: 'fade',

loop: true,
    centeredSlides: false,
    navigation: {
        nextEl: '[js-slider-values-next]',
        prevEl: '[js-slider-values-prev]',
    },
});
//bind both sliders
// if (document.querySelector(settings.valuesTextSliderSelector)) {
//     valuesTextSlider.controller.control = valuesImagesSlider;
//     valuesImagesSlider.controller.control = valuesTextSlider;
// }


let flexSlider = new Swiper(settings.flexSliderSelector, {
    slidesPerView: 1,
    spaceBetween: 0,
    centeredSlides: false,
    grabCursor: true,
    loop: false,
    navigation: {
        nextEl: '[js-flex-slider-next]',
        prevEl: '[js-flex-slider-prev]',
    },

    breakpoints: {
        720: {
            slidesPerView: 2,
        },
        960: {
            slidesPerView: 3,
        }
    }
});

/*--------------------------
Slider reassurance
--------------------------*/

let reassuranceSlider = new Swiper(settings.reassuranceSliderSelector, {
    slidesPerView: 1,
    spaceBetween: 48,
    centeredSlides: false,
    grabCursor: true,
    navigation: {
        nextEl: '[js-reassurance-next]',
        prevEl: '[js-reassurance-prev]',
    },
    breakpoints: {
        720: {
            slidesPerView: 2,
        },
        960: {
            slidesPerView: 4,
        },
        1200: {
            slidesPerView: 6,
        }
    }
});

